/* HUSHLY KIDS : barre collante de la fiche, mobile. Voir snippets/hushly-sticky-buy.liquid.
   22/09/2026 : deux temps (bouton jaune avant les packs, barre produit apres). */
(function () {
  function init() {
    var bar = document.querySelector('[data-hk-sticky]');
    if (!bar || bar.getAttribute('data-ready') === '1') return;
    bar.setAttribute('data-ready', '1');
    var box = document.querySelector('.hb-pdp');
    if (!box) { bar.parentNode.removeChild(bar); return; }
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    document.body.classList.add('hk-has-sticky');

    var mq = window.matchMedia('(max-width: 749px)');
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var info = box.closest('product-info') || document;
    var packs = box.querySelector('[data-hb-packs]');
    var head = document.querySelector('.hb-packs-h') || packs;
    var firstAge = box.querySelector('select[data-hb-age]');
    var cta = bar.querySelector('[data-cta]'), chip = bar.querySelector('[data-chip]'), chipT = bar.querySelector('[data-chip-t]');
    var b = bar.querySelector('[data-b]'), img = bar.querySelector('[data-img]');
    var prices = {};
    try { prices = JSON.parse(box.getAttribute('data-hb-prices') || '{}'); } catch (e) {}

    function chosen() { return firstAge ? !!firstAge.value : true; }
    function realBtn() { return info.querySelector('button[name="add"]') || document.querySelector('product-form button[name="add"]'); }
    function court(v) { var m = String(v).match(/(\d+)\s*to\s*(\d+)/i); return m ? m[1] + '-' + m[2] + ' yrs' : v; }
    function aller(el, off) {
      if (!el) return;
      var y = el.getBoundingClientRect().top + window.scrollY - (off || 90);
      window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    }
    function flash(el, cls, ms) {
      if (!el) return;
      el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls);
      setTimeout(function () { el.classList.remove(cls); }, ms || 1600);
    }

    function render() {
      var r = box.querySelector('.hb-pk__r:checked');
      var card = r && r.closest('[data-hb-pk]');
      var pic = card && card.querySelector('img');
      if (img && pic && pic.currentSrc) img.src = pic.currentSrc;
      var pack = (r && r.getAttribute('data-pack')) || '';
      var now = prices[pack] || '';
      if (!now && card) { var nb = card.querySelector('.hb-pk__price b'); now = nb ? nb.textContent.trim() : ''; }
      var n = parseInt(pack, 10) || 1;

      if (!chosen()) {
        chipT.textContent = bar.getAttribute('data-noage') || 'Choose age';
        b.textContent = bar.getAttribute('data-choose') || 'Choose size';
        return;
      }
      var ages = [firstAge.value];
      Array.prototype.forEach.call(box.querySelectorAll('select[data-hb-ageprop]'), function (sx) {
        if (!sx.disabled && sx.value) ages.push(sx.value);
      });
      var same = ages.every(function (a) { return a === ages[0]; });
      chipT.textContent = same ? court(ages[0]) + (n > 1 ? ' ×' + n : '') : (bar.getAttribute('data-mixed') || 'Mixed ages');
      b.innerHTML = 'Add<span class="hk-long"> to basket</span>' + (now ? ' · ' + String(now).replace(/[<>&]/g, '') : '');
    }

    var drawer = document.querySelector('cart-drawer');
    function blocked() {
      return (drawer && drawer.classList.contains('active')) || document.body.classList.contains('overflow-hidden') || document.documentElement.style.overflow === 'hidden';
    }
    function update() {
      var mode = '';
      if (mq.matches && packs && !blocked()) {
        var pr = packs.getBoundingClientRect();
        var rb = realBtn(); var bb = rb ? rb.getBoundingClientRect() : pr;
        /* 08/10 (Antonin, V10, option 1) : plus de bouton jaune « Choose the right size » sur mobile, les packs sont juste sous la photo.
           Historique : 26/09 visible des le debut ; 08/10 matin visible apres la photo (clignotait 100 px). Pour le remettre : mode = 'cta' quand pr.top > window.innerHeight - 40. */
        if (bb.bottom < 0) mode = 'buy';
      }
      bar.classList.toggle('is-on', !!mode);
      bar.classList.toggle('hk-sticky--cta', mode === 'cta');
      bar.classList.toggle('hk-sticky--buy', mode === 'buy');
      bar.setAttribute('aria-hidden', mode ? 'false' : 'true');
      if ('inert' in bar) bar.inert = !mode;
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    if (mq.addEventListener) mq.addEventListener('change', update);
    if (drawer && window.MutationObserver) new MutationObserver(update).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    if (window.MutationObserver) new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('change', function (e) {
      if (!e.target || !box.contains(e.target)) return;
      setTimeout(function () { render(); update(); }, 80);
    });
    document.addEventListener('hushly:set-age', function () { setTimeout(render, 80); });

    /* 1. bouton jaune : descente douce jusqu'aux packs, puis le bloc pulse */
    cta.addEventListener('click', function () {
      aller(head, 80);
      setTimeout(function () { flash(packs, 'hk-pulse', 1400); }, reduce ? 0 : 550);
    });
    /* pastille des ages : retour au choix des ages */
    function versAges() {
      var cible = firstAge ? (firstAge.closest('[data-hb-agewrap]') || firstAge.closest('.hb-age') || firstAge) : packs;
      /* 03/10/2026 : le bloc de l'age arrive au centre de la zone visible (entre l'en-tete et
         cette barre) au lieu d'etre colle en haut. Avant : aller(cible, 110). */
      var r = cible.getBoundingClientRect();
      var hd = document.querySelector('.section-header, sticky-header, .header-wrapper');
      var haut = hd ? Math.min(Math.max(hd.getBoundingClientRect().height, 0), 140) : 0;
      var bas = window.innerHeight - (bar.offsetHeight || 0);
      var dispo = bas - haut;
      aller(cible, haut + (r.height < dispo ? (dispo - r.height) / 2 : 16));
      setTimeout(function () { flash(firstAge, 'hk-flash', 1600); }, reduce ? 0 : 450);
    }
    chip.addEventListener('click', versAges);
    b.addEventListener('click', function () {
      if (!chosen()) { versAges(); return; }
      var tries = 0;
      b.setAttribute('data-hk-wait', '1');
      (function go() {
        var rb = realBtn();
        if (rb && !rb.disabled) { b.removeAttribute('data-hk-wait'); rb.click(); return; }
        if (++tries < 20) { setTimeout(go, 100); return; }
        b.removeAttribute('data-hk-wait');
        if (rb) aller(rb, window.innerHeight / 2);
      })();
    });

    render();
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
